module.exports = __webpack_public_path__ + "static/media/overview_bg.cac817e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/tellit/overview_bg.jpg
// module id = 1110
// module chunks = 0